import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class MusterAttendanceService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  ESS_FillComboOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_FillCombo/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LoadAttendanceOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LoadAttendance/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SaveAttendanceOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SaveAttendance/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_AttendanceExcelDumpOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AttendanceExcelDump/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteWiseAttendanceSendToPOCOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteWiseAttendanceSendToPOC/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_UpdateDailyAttendanceSummaryOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_UpdateDailyAttendanceSummary/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_GetCompanyParameterOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_GetCompanyParameter/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_RemoveAttendanceOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_RemoveAttendance/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ValidateSaveAttendanceOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ValidateSaveAttendance/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteWiseAttendanceSendToPOCOASApproval(Detail: any = {}, ApiUrl: string) {
    return this.http.post<any>(ApiUrl + `ESS_SiteWiseAttendanceSendToPOCOAS/Approval`,
      Detail
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_GetPOCMailStatusOAS(Detail: any = {}, ApiUrl: string) {
    return this.http.post<any>(ApiUrl + `ESS_GetPOCMailStatus/OAS`,
      Detail
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteWiseAttendancePOCOASGenExcelPdf(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteWiseAttendancePOCOASGen/ExcelPdf`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_AttendanceIPOCAttachment_IUUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AttendanceIPOCAttachment_IU/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
